var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mx-2",attrs:{"dark":"","color":"grey","icon":""},on:{"click":function($event){return _vm.openActionMenu()}}},[_c('v-icon',[_vm._v("mdi-menu")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }